import { render, staticRenderFns } from "./ItsBaseTradingCountry.vue?vue&type=template&id=55b92b33&scoped=true&"
import script from "./ItsBaseTradingCountry.vue?vue&type=script&lang=js&"
export * from "./ItsBaseTradingCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b92b33",
  null
  
)

export default component.exports